import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { queryQuickFetch } from './earlyRequestHelper';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
const FORECASTING_URI = 'forecasting/v1';
const ACCURACY_OVER_TIME_URI = 'projection/accuracy-over-time';
const AGGREGATED_DEAL_ROLL_UPS_URI = 'overview/aggregated/deal-roll-ups';
const AGGREGATED_GOALS_URI = 'overview/aggregated/goals';
const AGGREGATED_SUBMISSIONS_URI = 'overview/aggregated/submissions';
const AI_OPT_IN_URI = 'ai-forecast-opt-in';
const CLOSED_WON_URI = 'overall/pipeline-value/closed-won';
const REP_DEAL_COLUMNS_URI = 'settings/rep-deal-column';
const DEAL_ROLLUPS_OVER_TIME_URI = 'change-over-time/deals';
const ENABLE_AI_OPT_IN_URI = 'ai-forecast-opt-in/enable';
const OVERALL_PIPELINE_VALUE_URI = 'overall/pipeline-value/deals';
const PROCESSING_DEALS_URI = 'mapping/processing-deals';
const SUBMISSIONS_OVER_TIME_URI = 'change-over-time/submissions';
export const fetchAggregatedSubmissions = data => http.post(`${FORECASTING_URI}/${AGGREGATED_SUBMISSIONS_URI}`, {
  data
});
export const fetchOverallPipelineValue = data => http.post(`${FORECASTING_URI}/${OVERALL_PIPELINE_VALUE_URI}?currencyCode=${data.currencyCode}`, {
  data
});
export const fetchClosedWonValue = data => http.post(`${FORECASTING_URI}/${CLOSED_WON_URI}`, {
  data
});
export const fetchAccuracyProjectionOverTime = data => http.post(`${FORECASTING_URI}/${ACCURACY_OVER_TIME_URI}`, {
  data
});
export const fetchAIOptInStatus = () => queryQuickFetch(EARLY_REQUESTER_KEYS.AI_PROJECTIONS_OPT_IN, () => http.get(`${FORECASTING_URI}/${AI_OPT_IN_URI}`));
export const enableAIProjectionsOptIn = () => http.put(`${FORECASTING_URI}/${ENABLE_AI_OPT_IN_URI}`);

// TODO: type request payload
export const updatePipelineMapping = data => http.put(`${FORECASTING_URI}/mapping`, {
  data
}).then(fromJS);
export const updatePortalWideCadence = data => http.put(`${FORECASTING_URI}/pipeline-cadence/portal`, {
  data
});
export const fetchPortalWideCadence = () => queryQuickFetch(EARLY_REQUESTER_KEYS.PORTAL_CADENCE, () => http.get(`${FORECASTING_URI}/pipeline-cadence/portal`));
export const saveForecastAmountPipelineConfig = value => http.post(`${FORECASTING_URI}/portal-configuration`, {
  data: {
    forecastDealAmountConfiguration: value
  }
});
export const fetchForecastAmountPipelineConfig = () => queryQuickFetch(EARLY_REQUESTER_KEYS.PORTAL_CONFIGURATION, () => http.get(`${FORECASTING_URI}/portal-configuration`));
export const fetchAggregatedDealRollups = data => http.post(`${FORECASTING_URI}/${AGGREGATED_DEAL_ROLL_UPS_URI}`, {
  data
});
export const fetchAggregatedGoals = data => http.post(`${FORECASTING_URI}/${AGGREGATED_GOALS_URI}`, {
  data
});
export const fetchDealRollupsOverTime = data => http.post(`${FORECASTING_URI}/${DEAL_ROLLUPS_OVER_TIME_URI}`, {
  data
});
export const fetchSubmissionChangeOverTime = data => http.post(`${FORECASTING_URI}/${SUBMISSIONS_OVER_TIME_URI}`, {
  data
});
export const fetchPipelineValue = data => http.post(`${FORECASTING_URI}/${OVERALL_PIPELINE_VALUE_URI}`, {
  data
});
export const fetchProcessingDealsStatus = () => queryQuickFetch(EARLY_REQUESTER_KEYS.PROCESSING_DEALS_STATUS, () => http.get(`${FORECASTING_URI}/${PROCESSING_DEALS_URI}`));

// TODO: type request payload
export const fetchGoalsBreakdownForOwnerOrTeam = data => http.post(`forecasting/v1/overview/aggregated/goal/progress-breakdown`, {
  data
});
export const fetchForecastTypes = () => queryQuickFetch(EARLY_REQUESTER_KEYS.FORECAST_TYPES, () => http.get(`${FORECASTING_URI}/settings/forecast-type`));
export const fetchRepDealColumns = () => http.get(`${FORECASTING_URI}/${REP_DEAL_COLUMNS_URI}`);
export const fetchDefaultRepDealColumns = forecastTypeId => http.get(`${FORECASTING_URI}/settings/portal-default-deal-column/${forecastTypeId}`);
export const updateRepDealColumns = (dealColumns, forecastTypeId) => http.put(`${FORECASTING_URI}/${REP_DEAL_COLUMNS_URI}`, {
  data: {
    dealColumns,
    forecastTypeId
  }
});
export const deleteRepDealColumns = forecastTypeId => http.delete(`${FORECASTING_URI}/${REP_DEAL_COLUMNS_URI}/${forecastTypeId}`);